import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import * as bootstrap from 'bootstrap';
import {
  Router,
  ActivatedRoute,
  RouterModule,
  NavigationEnd,
} from '@angular/router';
import { CommonModule, DatePipe, NgFor, NgIf } from '@angular/common';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BusyService } from '../../_services/busy.service';
import { DatasearchService } from '../../_services/datasearch.service';
import { ExportDataService } from '../../_services/export-data.service';
import { AuthenticationService } from '../../_services/authentication.service';
import { ConstantService } from '../../_services/constant.service';
import { search_filter } from '../../../_model/search_fliter';
import { user_privilege } from '../../../_model/user_privilege';
import { filter } from 'rxjs/operators';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommanService } from '../../_services/comman.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { GlobalService } from '../../_services/global.service';

declare var $: any;
@Component({
  selector: 'app-platform',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    FooterComponent,
    ToastModule,
    RouterModule,
    ReactiveFormsModule,
    NgFor,
    NgIf,
    CommonModule,
    DialogModule,
    ButtonModule,
    FormsModule,
    SidebarComponent
  ],
  templateUrl: './platform.component.html',
  styleUrl: './platform.component.scss',
  providers: [MessageService],
})
export class PlatformComponent {
  selectedTab: number = 0;
  currGBRN: any = 0;
  dataAvailablity: any[] = [];
  isAdmin: boolean = false;
  TableName: string = 'basic_product_details_MONGO';
  pageTitile = 'QuikPatent';
  toggle_sidebar: boolean = true;
  isSignedIn = false;
  data: any[] = [];
  allData: any[] = [];
  current_pagenumber: number = 1;
  Default_DownloadRec_Limit: number = 500;
  maxWords: number = 80;
  maxLines: number = 9.5; // Max lines to display before truncating
  readMoreText: string = 'Read More';
  readLessText: string = 'Read Less';
  currentFilterCondition: any = [];
  form_RaiseQuery: FormGroup = new FormGroup({});
  isShowRaiseQuery: boolean = false;
  currentSortBy: string = '';
  application_query: string = '';
  search_filters!: search_filter;
  user_ip: string = '';
  address: string = '';
  transparent = true;
  accountType: string = '';
  user_data: any;
  additionalOperator: string = '';
  rptDataForExcel: any = [];
  listener: (() => void) | undefined;
  cols: any[] = [];
  isVisible = false;
  columns: any[] = [];
  userid: any[] = [];
  fullImageUrl: string | null = null;
  moaImageUrl: string | null = null;
  keggImageUrl: string | null = null;
  totalRecords: number;
  oldRecords: number;
  gbrnArray: string[] = [];
  INCHIKEY: string = '';
  inchiKeyArray: string[] = [];
  privilege_json!: user_privilege;
  is_show_Total_Search_Exceed_popup: boolean = false;
  is_show_Search_Priv_popup: boolean = false;
  is_show_Daily_Search_Exceed_popup: boolean = false;
  is_show_Download_Priv_popup: boolean = false;
  is_show_Daily_Download_Exceed_popup: boolean = false;
  is_show_Total_Download_Exceed_popup: boolean = false;
  breadcrumbItems: Array<{ label: string; url: string }> = [];
  private mapRouteToLabel: { [key: string]: string } = {
    platform: 'Platform',
    'product-information': 'Product Information',
    'technical-route': 'Technical Route',
    'mrl-database': 'MRL Database',
    'gapd-database': 'Gapd Database',
    detail: 'Detail',
  };

  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  constructor(
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router,

    private el: ElementRef,
    private renderer: Renderer2,
    private busyService: BusyService,
    private datasearch: DatasearchService,
    private exportdataService: ExportDataService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private commanService: CommanService,
    private activatedRoute: ActivatedRoute,
    private globalService: GlobalService
  ) {
    const navigation = this.router.getCurrentNavigation();

    const state = navigation?.extras.state as {
      data: any;
      allData: any;
      userid: string[];
      gbrnArray: string[];
      inchiKeyArray: string[];
      privilege_json: user_privilege;
      currentFilterCondition: any;
      application_query: string; // Added the application_query
      search_filters: search_filter; // Added the search_filters
      cols: any; // Changed from `any[]` to `any` to handle non-array values
      columns: any[]; // Added the columns property
      searchQueryGrid: string[];
      totalRecords: any;
      oldRecords: any;
      gbrn: any;
    };
    // Assign values from the state
    this.data = state?.data || {}; // Default to empty object if no data is passed
    this.allData = state?.allData || {};
    this.userid = state?.userid || []; // Default to empty array if no userId is passed
    this.gbrnArray = state?.gbrnArray || []; // Assign gbrnArray or default to empty array
    this.inchiKeyArray = state?.inchiKeyArray || []; // Assign inchiKeyArray or default to empty array
    
    // Load privilege from localStorage or fallback to state
    const savedPrivilege = localStorage.getItem('user_privilege');
    if (savedPrivilege) {
      try {
        const parsed = JSON.parse(savedPrivilege);
        const appKey = 'agropat-ultimate-discovery-suite-beta';
        this.privilege_json = parsed[appKey] || parsed;
      } catch (e) {
        console.error('Error loading privilege from localStorage:', e);
        this.privilege_json = state?.privilege_json || {};
      }
    } else {
      this.privilege_json = state?.privilege_json || {};
    }

    this.currentFilterCondition = state?.currentFilterCondition || [];
    this.application_query = state?.application_query || ''; // Default to empty string if no value is passed
    this.search_filters = state?.search_filters || {};
    this.cols = state?.cols || {}; // Default to empty object or appropriate default
    this.columns = state?.columns || []; // Assign columns or default to an empty array
    this.searchQueryGrid = state?.searchQueryGrid || null;
    this.totalRecords = state?.totalRecords || 0;
    this.oldRecords = state?.oldRecords;
    this.currGBRN = state?.gbrn || 0;

    if (this.data && Array.isArray(this.data)) {
      this.data = this.data.map((item: any) => {
        const filteredItem: any = {};

        // Iterate over each key in the object
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            filteredItem[key] =
              typeof item[key] === 'string'
                ? item[key].replace(/\r/g, '') // Replace '\r' with an empty string
                : item[key]; // Keep non-string values unchanged
          }
        }
        return filteredItem;
      });
    } else {
      console.warn('Unexpected format for `data`:', this.data);
    }

    if (Array.isArray(this.cols)) {
    } else if (typeof this.cols === 'object' && this.cols !== null) {
      // Convert object to an array format if needed
      this.cols = Object.keys(this.cols).map((key) => ({
        field: key,
        value: this.cols,
      }));
    } else {
      console.warn('Unexpected format for `cols`:', this.cols);
    }
    // Handle additional logic for columns if needed
    if (this.columns && this.columns.length > 0) {
      this.columns.forEach((col) => {
        // Add additional processing for each column if needed
      });
    }
  }
  searchQueryGrid: any = '';
  ngOnInit() {
    this.form_RaiseQuery = this.fb.group({
      txtResponseEmail: [''],
      txtQuery: [''],
    });
    setTimeout(() => {
      this.globalService.sendMenuIndex(0); // Set active sidebar menu to Search
    }, 0);
    this.enableDragScroll();
    this.commanService.productInformationData.subscribe((res: any) => {
      this.searchQueryGrid = res.searchQueryGrid || '';
      // console.log("search query get from productInformation : ",this.searchQueryGrid)
    });
    // Subscribe to privilege changes
    this.commanService.getUserPrivilege().subscribe((privilege: any) => {
      this.privilege_json = privilege;
    });

    window.onload = () => {
      this.router.navigate(['']);
    };
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.buildBreadcrumbs(this.router.url);
      });

    const currentUrl = this.router.url;

    const routeToFunctionMap: { [key: string]: string } = {
      '/platform/product-information': 'productinformation',
      '/platform/technical-route': 'technicalroutepage',
      '/platform/important-patent-database': 'impdatabase',
      '/platform/gapd-database': 'gapddatabase',
      '/platform/ipd-database': 'ipddatabase',
      '/platform/impurity-database': 'impuritydatabase',
      '/platform/cipac-database': 'cipacdatabase',
      '/platform/mrl-database': 'mrldatabase',
      '/platform/quik-patent-database': 'quikpatentdatabase',
      '/platform/non-patent-database': 'nonpatentdatabase',
      '/platform/spc-database': 'spcdatabase',
      '/platform/litigation-database': 'litigationdatabase',
      '/platform/scientific-docs-database': 'docsdatabase',
    };

    const functionName = routeToFunctionMap[currentUrl];

    if (functionName) {
      const tabIndex = this.tabs.findIndex(
        (tab: any) => tab.functionName === functionName
      );
      if (tabIndex !== -1) {
        this.selectedTab = tabIndex;
      }
    }
    this.authentication.getCurrentUserValue().subscribe((val: any) => {
      this.user_data = val;
      if (this.user_data.userid) {
        this.getUserAccountType(this.user_data.userid);
      }
    });
  }

  tabs = [
    { label: 'PRODUCT INFORMATION', functionName: 'productinformation' },
    { label: 'MANUFACTURING SYNTHESIS', functionName: 'technicalroutepage' },
    { label: 'IMPORTANT PATENTS', functionName: 'impdatabase' },

    { label: 'GLOBAL PESTICIDE APPROVAL', functionName: 'gapddatabase' },
    { label: 'INDIAN PESTICIDE APPROVAL', functionName: 'ipddatabase' },
    { label: 'IMPURITY', functionName: 'impuritydatabase' },

    { label: 'ANALYTICAL METHODS (CIPAC)', functionName: 'cipacdatabase' },

    { label: 'MRL', functionName: 'mrldatabase' },
    { label: 'QUICK PATENT', functionName: 'quikpatentdatabase' },
    { label: 'NON - PATENT', functionName: 'nonpatentdatabase' },
    { label: 'SPC', functionName: 'spcdatabase' },
    { label: 'PATENT LITIGATION', functionName: 'litigationdatabase' },
    { label: 'SCIENTIFIC DOCS.', functionName: 'docsdatabase' },
  ];
  changeTab(index: number, functionName: string) {
    this.selectedTab = index;

    // ✅ Use a type assertion to ensure TypeScript understands the dynamic call
    if (typeof (this as any)[functionName] === 'function') {
      ((this as any)[functionName] as Function)();
    } else {
      console.error(`Function ${functionName} does not exist`);
    }
  }
  enableDragScroll() {
    const tabContent = document.querySelector('.tab-content') as HTMLElement;
    let isDown = false;
    let startX: number;
    let scrollLeft: number;

    if (tabContent) {
      tabContent.addEventListener('mousedown', (e) => {
        isDown = true;
        tabContent.classList.add('active'); // Optional: Add effect when dragging
        startX = e.pageX - tabContent.offsetLeft;
        scrollLeft = tabContent.scrollLeft;
      });

      tabContent.addEventListener('mouseleave', () => {
        isDown = false;
        tabContent.classList.remove('active');
      });

      tabContent.addEventListener('mouseup', () => {
        isDown = false;
        tabContent.classList.remove('active');
      });

      tabContent.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - tabContent.offsetLeft;
        const walk = (x - startX) * 2; // Adjust speed
        tabContent.scrollLeft = scrollLeft - walk;
      });
    }
  }
  showToast() {
    this.messageService.add({
      severity: 'info ',
      summary: 'Coming Soon',
      detail: 'This feature is coming soon!',
    });
  }
  goBack(): void {
    this.totalRecords = this.data.length;

    this.router.navigate(['/search'], {
      state: {
        allData: this.allData,
        userid: this.userid,
        gbrnArray: this.gbrnArray,
        inchiKeyArray: this.inchiKeyArray,
        privilege_json: this.privilege_json,
        currentFilterCondition: this.currentFilterCondition,
        application_query: this.application_query,
        search_filters: this.search_filters,
        cols: this.cols,
        columns: this.columns,
        searchQueryGrid: this.searchQueryGrid,
        totalRecords: this.totalRecords,
        oldRecords: this.oldRecords,
      },
    });
  }
  technicalroutepage() {
    this.router.navigate(['/platform/technical-route']);
  }
  productinformation() {
    this.router.navigate(['/platform/product-information']);
  }
  mrldatabase() {
    this.router.navigate(['/platform/mrl-database']);
  }
  gapddatabase() {
    this.router.navigate(['/platform/gapd-database']);
  }
  impdatabase() {
    this.router.navigate(['/platform/important-patent-database']);
  }
  impuritydatabase() {
    this.router.navigate(['/platform/impurity-database']);
  }
  cipacdatabase() {
    this.router.navigate(['/platform/cipac-database']);
  }
  nonpatentdatabase() {
    this.router.navigate(['/platform/non-patent-database']);
  }
  litigationdatabase() {
    this.router.navigate(['/platform/litigation-database']);
  }
  docsdatabase() {
    this.router.navigate(['/platform/scientific-docs-database']);
  }
  spcdatabase() {
    this.router.navigate(['/platform/spc-database']);
  }
  quikpatentdatabase() {
    this.router.navigate(['/platform/quik-patent-database']);
  }
  ipddatabase() {
    this.router.navigate(['/platform/ipd-database']);
  }
  showRaiseQuery() {
    // Clear form controls
    this.form_RaiseQuery.controls['txtResponseEmail'].setValue('');

    this.form_RaiseQuery.controls['txtQuery'].setValue('');

    this.isShowRaiseQuery = true;

    // Fetch the modal element
    const modalElement = document.getElementById('raise_query_modal');

    if (modalElement) {
      // Initialize and display the modal
      const modalInstance = new bootstrap.Modal(modalElement);

      if (modalInstance) {
        modalInstance.show();
      } else {
        console.error('Failed to initialize modal instance.');
      }
    } else {
      console.error('Modal element not found!');
    }
  }
  // Raise Query old way
  // submitRaiseQueryForm() {
  //   // Prepare email data
  //   let emailPostData = {
  //     to: 'support@chemrobotics.com',
  //     subject: 'ChemRobotics - Discovery-suite-beta - User Query',
  //     html: `
  //           <div style="background-color: #ffc702; heigth:30px; text-align: center;">
  //           <img src="cid:logoImg" alt="Logo">
  //           </div>
  //           <div style="background-color: #eee;">
  //           <p>User Email: (<strong>${this.form_RaiseQuery.controls['txtResponseEmail'].value}</strong>)</p>
  //           <p>User Comment: <strong>${this.form_RaiseQuery.controls['txtQuery'].value}</strong></p>
  //           <p>Search Query:</p>
  //           </div>
  //           <p>${this.searchQueryGrid}</p>
  //           <div style="background-color: #eee;">
  //           <p>Thank You!</p>
  //           <p>Team ChemRobotics</p>
  //           <p><img src="cid:logoImg" alt="Logo"></p>
  //           <p><strong>✉️ support@chemrobotics.com</strong></p>
  //           <p><strong>📞 +91-6266117944</strong>, <strong>+91-9407360810</strong></p>
  //           </div>
  //           <hr>
  //           <div style="background-color: #eee; text-align: center;">
  //           <p>Copyright 2023 <strong><a href="https://www.chemrobotics.com/">ChemRobotics</a></strong></p>
  //           <div/>`,
  //   };

  //   // Prepare user query data
  //   let postdata = {
  //     mode: 'ADD_USER_QUERY',
  //     userid: this.user_data,
  //     usercomment: this.form_RaiseQuery.controls['txtQuery'].value,
  //     searchquery: this.search_filters,
  //   };

  //   // Log post data for debugging

  //   // Send user query data
  //   this.datasearch.userMasterManage(postdata).subscribe(
  //     (res) => {
  //       // Log success respons
  //     },
  //     (err) => {
  //       // Log error response
  //     }
  //   );

  //   // Send email data
  //   this.datasearch.sendMail(emailPostData).subscribe(
  //     (res) => {
  //       // Log success response

  //       // Update UI after success
  //       this.isShowRaiseQuery = false;
  //       this.submittedquerybox();

  //       // Log UI update;
  //     },
  //     (err) => {
  //       // Log error response
  //       console.error('Error sending email:', err);
  //     }
  //   );
  // }
  // Raise Query new way
  submitRaiseQueryForm() {
    let emailPostData = new FormData();
    emailPostData.append('to', ' support@chemrobotics.com');
    emailPostData.append('cc', 'greenbookcorp@gmail.com');
    emailPostData.append('cc', 'chemroboticsros@gmail.com');
    // emailPostData.append('to', ' yashranka1312@gmail.com');
    // emailPostData.append('cc', 'yjain8588@gmail.com');
    // emailPostData.append('cc', 'devendrateliofficial@gmail.com');
    emailPostData.append(
      'subject',
      'ChemRobotics - Agropat Discovery Suite - User Query'
    );
    emailPostData.append(
      'html',
      `
            <div style="background-color: #ffc702; heigth:30px; text-align: center;">
              <img src="cid:logoImg" alt="Logo">
            </div>
            <div style="background-color: #eee;">
             <p>User Email: (<strong>${this.form_RaiseQuery.controls['txtResponseEmail'].value}</strong>)</p>
             <p>User Comment: <strong>${this.form_RaiseQuery.controls['txtQuery'].value}</strong></p>
             <p>Search Query:</p>
            </div>
            <p>${this.searchQueryGrid}</p>
            <div style="background-color: #eee;">
             <p>Thank You!</p>
             <p>Team ChemRobotics</p>
             <p><img src="cid:logoImg" alt="Logo"></p>
             <p><strong>✉️ support@chemrobotics.com</strong></p>
             <p><strong>📞 +91-6266117944</strong>, <strong>+91-9407360810</strong></p>
            </div>
            <hr>
            <div style="background-color: #eee; text-align: center;">
             <p>Copyright 2023 <strong><a href="https://www.chemrobotics.com/">ChemRobotics</a></strong></p>
            <div/>`
    );

    if (this.selectedFile) {
      emailPostData.append('file', this.selectedFile);
    }
    // debugger
    let postdata = {
      mode: 'ADD_USER_QUERY',
      userid: this.userid,
      usercomment: this.form_RaiseQuery.controls['txtQuery'].value,
      searchquery: this.search_filters,
    };

    this.datasearch.userMasterManage(postdata).subscribe((res) => {});
    this.busyService.busy();
    this.datasearch.sendMailNew(emailPostData).subscribe(
      (res) => {
        this.busyService.idle();
        this.isShowRaiseQuery = false;
        this.form_RaiseQuery.reset({
          txtResponseEmail: '',
          txtQuery: '',
        });
        this.fileInput.nativeElement.value = '';
        this.selectedFile = null;
        this.submittedquerybox();
        this.messageService.add({
          severity: 'success',
          detail: 'Query raised successfully!',
        });
      },
      (error) => {
        this.busyService.idle();
        console.log('Error on Raise Query : ', error);
      }
    );
  }
  submittedquerybox() {
    const alertModalElement = document.getElementById('Querysubmitalert');
    if (alertModalElement) {
      $('#Querysubmitalert').modal('show');
      setTimeout(() => {
        $('#Querysubmitalert').modal('hide');
      }, 5000); // Close the alert modal after 5 seconds
    }
  }
  // Raise Query file upload veriables
  @ViewChild('fileInput') fileInput!: ElementRef;
  selectedFile: File | null = null;
  maxFileSizeMB = 10;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      if (file.size > this.maxFileSizeMB * 1024 * 1024) {
        alert('File is too large. Please select a file under 10 MB.');
        this.fileInput.nativeElement.value = '';
        this.selectedFile = null;
        return;
      }

      this.selectedFile = file;
    }
  }

  buildBreadcrumbs(url: string) {
    const segments = url.split('/').filter((seg) => seg);
    const breadcrumbs: Array<{ label: string; url: string }> = [];

    let path = '';
    segments.forEach((seg) => {
      path += `/${seg}`;
      const label = this.mapRouteToLabel[seg] || seg;
      breadcrumbs.push({ label, url: path });
    });

    this.breadcrumbItems = breadcrumbs;
  }

  onBreadcrumbClick(url: string) {
    if (this.router.url === url) {
      // Reload current route
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([url]);
      });
    } else {
      this.router.navigate([url]);
    }
  }
  getUserAccountType(userId: string) {
    this.datasearch.getUserAccountType(userId).subscribe({
      next: (res: any) => {
        this.accountType = res.account_type || '';
      },
      error: (err) => {
        console.error('Error while fetching account type:', err); // On error
      },
    });
  }
  scrollTabs(direction: 'left' | 'right') {
    if (!this.scrollContainer) return;
    const el = this.scrollContainer.nativeElement as HTMLElement;
    const scrollAmount = 200;

    el.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  }

  // PDF Work
  pdfPlatformDialog: boolean = false;
  pdfPlatforms: any[] = [
    {
      platformLable: 'PRODUCT INFORMATION',
      platformName: 'product_information',
      isSelected: false,
    },
    {
      platformLable: 'MANUFACTURING SYNTHESIS',
      platformName: 'manufacturing_synthesis',
      isSelected: false,
    },
    {
      platformLable: 'IMPURITY',
      platformName: 'impurity',
      isSelected: false,
    },
    {
      platformLable: 'ANALYTICAL METHODS (CIPAC)',
      platformName: 'analytical_methods_cipac',
      isSelected: false,
    },
  ];
  openPdfPlatformsDialog() {
    this.pdfPlatformDialog = true;
  }

  generatePdf(routeIndex?: number) {
    console.log('=== Starting PDF Generation Process ===');

    // Refresh privilege from localStorage
    const savedPrivilege = localStorage.getItem('user_privilege');
    if (savedPrivilege) {
      try {
        const parsed = JSON.parse(savedPrivilege);
        const appKey = 'agropat-ultimate-discovery-suite-beta';
        this.privilege_json = parsed[appKey] || parsed;
      } catch (e) {
        console.error('Error loading privilege from localStorage in generatePdf:', e);
      }
    }

    // Permission & limit checks
    if (!this.privilege_json || Object.keys(this.privilege_json).length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Loading...',
        detail: 'Please wait while we load your permissions',
      });
      return;
    }
    if (!this.privilege_json.Download) {
      this.messageService.add({
        severity: 'error',
        summary: 'No Permission',
        detail: 'You do not have permission to download PDFs',
      });
      return;
    }
    const currentCount = this.privilege_json.today_download_count || 0;
    const dailyLimit = this.privilege_json.DailyDownloadLimit || 0;
    if (currentCount >= dailyLimit) {
      this.messageService.add({
        severity: 'error',
        summary: 'Download Limit Reached',
        detail: `You have reached your daily download limit of ${dailyLimit} reports.`,
      });
      this.is_show_Daily_Download_Exceed_popup = true;
      return;
    }

    const selectedPlatforms = this.pdfPlatforms.filter((p) => p.isSelected);
    if (selectedPlatforms.length === 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select at least one platform to generate PDF',
      });
      return;
    }

    const searchQuery = this.getActiveIngredient();
    if (!searchQuery) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No search query found',
      });
      return;
    }

    const userId = this.user_data?.userid;
    const currentGbrn = this.commanService.currentgbrn.value;
    if (!userId || !currentGbrn) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'User or GBRN info missing',
      });
      return;
    }

    // Build payload
    const postdata: any = {
      searchQuery,
      platformData: [],
      userPrivilege: this.privilege_json,
      userId,
    };
    const reportLimit = this.privilege_json.ReportLimit || 0;

    selectedPlatforms.forEach((platform) => {
      const platformPayload: any = {
        platformName: platform.platformName,
        platformLabel: platform.platformLable,
        postdata: { userid: userId },
      };

      switch (platform.platformName) {
        case 'product_information':
          platformPayload.postdata = {
            ...platformPayload.postdata,
            mode: 'GET_DATA',
            tablename: 'basic_product_details_MONGO',
            filterconditionQuikPatent: [
              {
                $or: [
                  { ACTIVE_INGREDIENT: { $regex: searchQuery, $options: 'i' } },
                ],
              },
              { isDeleted: { $ne: true } },
            ],
            application_query: `ACTIVE INGREDIENT:(${searchQuery})`,
            searchQueryGrid: `ACTIVE INGREDIENT:(${searchQuery})`,
          };
          break;

        case 'manufacturing_synthesis':
          platformPayload.postdata = {
            ...platformPayload.postdata,
            table_name: 'TECHNICAL_ROUTE_MONGO',
            gbrn: currentGbrn,
            filter: {},
            sortBy: 'default',
          };
          if (reportLimit > 0) {
            platformPayload.postdata.pagenumber = 1;
            platformPayload.postdata.limit = reportLimit;
          }
          if (this.privilege_json.SplitDownload && routeIndex !== undefined) {
            platformPayload.postdata.recordId = routeIndex;
          }
          break;

        case 'impurity':
          platformPayload.postdata = {
            ...platformPayload.postdata,
            gbrn: currentGbrn,
            filters: { category: '' },
          };
          break;

        case 'analytical_methods_cipac':
          platformPayload.postdata = {
            ...platformPayload.postdata,
            gbrn: currentGbrn,
            filters: {},
            sortby: 'title ASC',
          };
          break;
      }

      if (!reportLimit || reportLimit === 0) {
        delete platformPayload.postdata.pagenumber;
        delete platformPayload.postdata.limit;
        delete platformPayload.postdata.rowscount;
      }

      postdata.platformData.push(platformPayload);
    });

    this.busyService.busy();
    const startTime = performance.now();

    this.datasearch.generatePdf(postdata).subscribe({
      next: (res: HttpResponse<Blob>) => {
        this.busyService.idle();
        const blob = res.body;

        if (blob && blob.type === 'application/pdf') {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          // Generate filename based on selected platforms
          const selectedPlatforms = this.pdfPlatforms.filter(
            (p) => p.isSelected
          );
          let filename = 'discovery_report';

          if (selectedPlatforms.length === 1) {
            // If only one platform is selected, use its label
            filename = selectedPlatforms[0].platformLable
              .toLowerCase()
              .replace(/\s+/g, '_')
              .replace(/[^a-z0-9_]/g, '')
              .replace(/_+/g, '_');
          } else if (selectedPlatforms.length === 2) {
            // If two platforms are selected, combine their labels with &
            const firstLabel = selectedPlatforms[0].platformLable
              .toLowerCase()
              .replace(/\s+/g, '_')
              .replace(/[^a-z0-9_]/g, '')
              .replace(/_+/g, '_');
            const secondLabel = selectedPlatforms[1].platformLable
              .toLowerCase()
              .replace(/\s+/g, '_')
              .replace(/[^a-z0-9_]/g, '')
              .replace(/_+/g, '_');
            filename = `${firstLabel}_&_${secondLabel}`;
          } else if (selectedPlatforms.length === this.pdfPlatforms.length) {
            // If all platforms are selected, use 'discovery_report'
            filename = 'discovery_report';
          } else if (selectedPlatforms.length > 2) {
            // If more than two platforms are selected, use 'discovery_report'
            filename = 'discovery_report';
          }

          // Add date to filename
          const date = new Date().toISOString().split('T')[0];
          link.download = `${filename}_${date}.pdf`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.pdfPlatformDialog = false;
          this.resetPdfPlatforms();
          this.privilege_json.today_download_count =
            (this.privilege_json.today_download_count || 0) + 1;

          // Save updated counts to localStorage under daily_counts
          const today = new Date().toDateString();
          const userData = {
            date: today,
            today_search_count: this.privilege_json.today_search_count || 0,
            today_download_count: this.privilege_json.today_download_count,
          };
          localStorage.setItem(
            `user_${userId}_daily_counts`,
            JSON.stringify(userData)
          );

          // Update privilege in commanService, which will save to user_privilege in localStorage and notify all subscribers
          this.commanService.setUserPrivilege(this.privilege_json);

          const duration = ((performance.now() - startTime) / 1000).toFixed(2);
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'PDF generated successfully',
          });
          console.log(`✓ PDF generated successfully in ${duration} seconds`);
        } else {
          // Backend sent JSON error instead of PDF
          this.readErrorBlob(blob!).then((json: any) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: json.message || 'Failed to generate PDF',
            });

            if (json.message.toLowerCase().includes('permission'))
              this.is_show_Download_Priv_popup = true;
            else if (json.message.toLowerCase().includes('limit'))
              this.is_show_Daily_Download_Exceed_popup = true;
          });
        }
      },
      error: (err: any) => {
        this.busyService.idle();
        if (err.error instanceof Blob) {
          this.readErrorBlob(err.error)
            .then((json: any) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: json.message || 'Failed to generate PDF',
              });
            })
            .catch(() => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to generate PDF',
              });
            });
        } else {
          const message = err?.message || 'Failed to generate PDF';
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: message,
          });
        }
        console.error('PDF Generation Error:', err);
      },
      complete: () => console.log('=== PDF Generation Process Completed ==='),
    });
  }

  private readErrorBlob(blob: Blob): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const json = JSON.parse(reader.result as string);
          resolve(json);
        } catch {
          reject(reader.result);
        }
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsText(blob);
    });
  }
  resetPdfPlatforms() {
    this.pdfPlatforms.forEach((platform) => {
      platform.isSelected = false;
    });
  }

  // Add this helper method to get the active ingredient
  private getActiveIngredient(): string {
    let searchTerm = '';

    // 1. Try to get it from current_Active_Ingredient BehaviorSubject
    if (this.commanService.current_Active_Ingredient.value) {
      return this.commanService.current_Active_Ingredient.value;
    }

    // 2. Try to get it from productInformationData
    this.commanService.productInformationData.subscribe((res: any) => {
      if (res) {
        if (res.activeIngredient) {
          searchTerm = res.activeIngredient;
        } else if (res.searchQueryGrid) {
          // Fallback to parsing searchQueryGrid with regex supporting optional whitespace
          const match = res.searchQueryGrid.match(
            /ACTIVE INGREDIENT:\s*\(([^)]+)\)/i
          );
          searchTerm = match ? match[1] : '';
        }
      }
    });

    return searchTerm;
  }

  receiveSidebarEvent(event: any) {
    this.toggle_sidebar = event;
  }

  receiveHeading(event: any) {
    // console.log('Heading Event : ', event);
  }
}
